import type { IButtonProps } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  menuTextChevronClass,
  menuTextContainerClass,
  menuTextLine2Class,
  splitContainerClass,
  splitIconClass,
  splitTextClass,
} from "@1js/acui-button";
import { ActionControlSize } from "@1js/acui-common";

import { getOnRenderText } from "../../Controls/onRenderText";
import type { RibbonControlProps } from "../../Controls/RibbonControlProps";
import { renderMLRLargeMenuAnchorText } from "../../renderMLRLargeMenuAnchorTextFunction";

export const getFlyoutAnchorProps = memoizeFunction(
  (size: ActionControlSize) => {
    if (size === ActionControlSize.Large) {
      return {
        onRenderText: (props: IButtonProps) => {
          return renderMLRLargeMenuAnchorText(
            props.text!,
            props.menuIconProps!,
            props.disabled,
            menuTextContainerClass,
            menuTextLine2Class,
            menuTextChevronClass
          );
        },
        // The menu icon is rendered by renderMLRLargeMenuAnchorText
        hideChevron: true,
      };
    }

    return {};
  }
);

const getSplitButtonProps = memoizeFunction((size: ActionControlSize) => {
  return {
    onRenderText:
      size === ActionControlSize.Large
        ? (props: IButtonProps) => {
            return renderMLRLargeMenuAnchorText(
              props.text!,
              props.menuIconProps!,
              props.disabled,
              splitContainerClass,
              splitTextClass,
              splitIconClass
            );
          }
        : getOnRenderText(size),
    vertical: size === ActionControlSize.Large,
  };
});

export function getRibbonControlGroupItemsProps(
  props: RibbonControlProps,
  size: ActionControlSize
): Partial<RibbonControlProps> {
  switch (props.type) {
    case "AppFlyoutAnchorProps":
      return getFlyoutAnchorProps(size);
    case "AppSplitButtonProps":
      return getSplitButtonProps(size);
    default:
      return {};
  }
}
